module.exports = __webpack_public_path__ + "static/media/logo.eda1fe23.png";